import React from 'react';
import { Surface } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import TinyPostCard from '@src/components/TinyPostCard';
import Title from '@src/components/Title';
import useLanguage from '@src/hooks/useLanguage';
import usePosts from '@src/hooks/usePosts';
import { PageItemAPI } from '@src/types';

import { PostsList } from './styled';

type Props = {
  data: PageItemAPI;
};

const Container = styled.View`
  width: 100%;
`;

const PostContainer = styled(Surface)`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  elevation: 4;
`;

const Component: React.FC<Props> = (props) => {
  const {
    data: { name, url, params },
  } = props;

  const language = useLanguage();
  const posts = usePosts(url, params);
  const navigation = useNavigation();

  const title = React.useMemo(() => name?.[language] ?? '', [language, name]);

  const handleViewMorePress = React.useCallback(() => {
    navigation.navigate('Posts', { title, url, params });
  }, [navigation, params, title, url]);

  return (
    <Container>
      <Separator />
      <Title onMorePress={handleViewMorePress}>{title}</Title>
      <PostsList
        data={posts.data}
        renderItem={({ item }) => (
          <PostContainer>
            <TinyPostCard item={item} />
          </PostContainer>
        )}
      />
    </Container>
  );
};

Component.displayName = 'PostItems';

export default React.memo(Component);
